<div class="card">
    <div class="font-semibold text-xl mb-4">Sucursales HOY</div>
    <p-chart type="line" [data]="chartData" [options]="chartOptions"></p-chart>
</div>
